import axiosInstance from './AxiosInstance';

const KycMasterService = {
  createKycMaster: async (kycData) => {
    try {
      const response = await axiosInstance.post('/kyc-master', kycData);
      return {
        success: response.data.success,
        data: response.data.data.kycMaster,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to create KYC master',
        errors: error.response?.data?.errors || []
      };
    }
  },

  getAllKycMasters: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.search) queryParams.append('search', params.search);
      if (params.status) queryParams.append('status', params.status);
      if (params.kycType) queryParams.append('kycType', params.kycType);
      if (params.documentType) queryParams.append('documentType', params.documentType);
      if (params.isRequired !== undefined) queryParams.append('isRequired', params.isRequired);

      const response = await axiosInstance.get(`/kyc-master?${queryParams.toString()}`);
      return {
        success: response.data.success,
        data: response.data.data.data,
        pagination: response.data.data.pagination,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch KYC masters',
        data: [],
        pagination: {}
      };
    }
  },

  getKycMasterById: async (id) => {
    try {
      const response = await axiosInstance.get(`/kyc-master/${id}`);
      return {
        success: response.data.success,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch KYC master',
        data: null
      };
    }
  },

  updateKycMaster: async (id, kycData) => {
    try {
      const response = await axiosInstance.put(`/kyc-master/${id}`, kycData);
      return {
        success: response.data.success,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update KYC master',
        errors: error.response?.data?.errors || []
      };
    }
  },

  deleteKycMaster: async (id) => {
    try {
      const response = await axiosInstance.delete(`/kyc-master/${id}`);
      return {
        success: response.data.success,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to delete KYC master'
      };
    }
  },

  getKycTypes: async () => {
    try {
      const response = await axiosInstance.get('/kyc-master/types');
      return {
        success: response.data.success,
        data: response.data.data.kycTypes,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch KYC types',
        data: []
      };
    }
  },

  getKYCSettings: async (params = {}) => {
    return await KycMasterService.getAllKycMasters(params);
  },

  addKYCSetting: async (kycData) => {
    return await KycMasterService.createKycMaster(kycData);
  },

  updateKYCSetting: async (id, kycData) => {
    return await KycMasterService.updateKycMaster(id, kycData);
  },

  fetchKYCSettingById: async (id) => {
    return await KycMasterService.getKycMasterById(id);
  },

  deleteKYCSettingById: async (id) => {
    return await KycMasterService.deleteKycMaster(id);
  },

  getActiveKycMasters: async () => {
    return await KycMasterService.getAllKycMasters({ status: 'ACTIVE' });
  },

  getRequiredKycMasters: async () => {
    return await KycMasterService.getAllKycMasters({ isRequired: true });
  },

  searchKycMasters: async (searchTerm) => {
    return await KycMasterService.getAllKycMasters({ search: searchTerm });
  },

  getKycMasterDropdown: async () => {
    try {
      const response = await axiosInstance.get('/kyc-master/dropdown');
      return {
        success: response.data.success,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch KYC master dropdown',
        data: []
      };
    }
  },

  // Get KYC Master statistics
  getKycMasterStatistics: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.companyId) queryParams.append('companyId', params.companyId);

      const url = `/statistics/kyc-master${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await axiosInstance.get(url);
      
      return {
        success: response.data.success,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch KYC master statistics',
        data: {
          text_count: 0,
          date_count: 0,
          file_count: 0,
          total_count: 0
        }
      };
    }
  }
};

export default KycMasterService;
